<template>
  <v-dialog
    v-model="toggle_dialog_add_point_state"
    max-width="500px"
  >
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-btn icon @click.native="toggle_dialog_add_point">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Add point</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
          <v-select
          :items="layers"
          label="Select layer"
          single-line
          auto
          prepend-icon="storage"
          hide-details
        ></v-select>
        <v-form>
          <v-text-field prepend-icon="place" name="login" label="Lat" id="lat" type="text"></v-text-field>
          <v-text-field prepend-icon="place" name="password" label="Long" id="lon" type="text"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary">Get Current Location</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    data () {
      return {
        layers: [
          'Hydrants', 'Image', 'Sign Structure'
        ]
      }
    },
    computed: {
      toggle_dialog_add_point_state: {
        get: function () {
          return this.$store.state.toggle.dialog.add.point
        },
        set: function () {
          this.toggle_dialog_add_point()
        }
      }
    },
    methods: {
      toggle_dialog_add_point () {
        this.$store.commit('toggleDialogAddPoint')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/dialogAddPoint.vue